/* Busca preditiva Steals — Painel Vitrine.
   Estados: empty (curadoria) | results | noresults | error.
   Resultados via section rendering (search/suggest + section_id=predictive-search).
   Mobile (<750px): takeover full-screen com scroll lock iOS-safe (mesmo padrão do menu drawer).
   Segurança: o innerHTML abaixo injeta APENAS HTML de section rendering da própria loja
   (mesma origem, Liquid escapa o termo do usuário com | escape). Texto dinâmico montado
   aqui no JS usa sempre textContent. Não usar innerHTML pra nenhuma outra fonte. */
if (!customElements.get('steals-predictive-search')) {
  class StealsPredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('[data-search-form]');
      this.input = this.querySelector('[data-search-input]');
      this.panel = this.querySelector('[data-search-panel]');
      if (!this.form || !this.input || !this.panel) return; // kill switch: sem painel, form estático

      this.results = this.querySelector('[data-search-results]');
      this.empty = this.querySelector('[data-search-empty]');
      this.noresults = this.querySelector('[data-search-noresults]');
      this.noresultsTerm = this.querySelector('[data-search-noresults-term]');
      this.error = this.querySelector('[data-search-error]');
      this.status = this.querySelector('[data-search-status]');
      this.cancelBtn = this.querySelector('[data-search-cancel]');
      this.clearBtn = this.querySelector('[data-search-clear]');

      this.mqMobile = window.matchMedia('(max-width: 749px)');
      this.cache = new Map(); // termo -> markup da seção (vida da página, máx 20 — backspace instantâneo)
      this.debounceT = null;
      this.controller = null;
      this.activeIndex = -1;
      this.options = [];
      this.savedScrollY = 0;

      // abrir: focus e click (click cobre re-abrir com input já focado)
      this.input.addEventListener('focus', this.open.bind(this));
      this.input.addEventListener('click', this.open.bind(this));
      // barra inteira é alvo de toque: tap no ícone/padding foca o input (senão parece "não abriu")
      var selfForm = this;
      this.form.addEventListener('click', function (e) {
        if (e.target === selfForm.input) return;
        if (selfForm.cancelBtn && selfForm.cancelBtn.contains(e.target)) return;
        if (selfForm.clearBtn && selfForm.clearBtn.contains(e.target)) return;
        selfForm.input.focus();
      });

      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      if (this.cancelBtn) {
        var self2 = this;
        this.cancelBtn.addEventListener('click', function () { self2.close(); self2.input.blur(); });
      }
      // × limpa o texto sem fechar (padrão StockX) e devolve o foco
      if (this.clearBtn) {
        var self3 = this;
        this.clearBtn.addEventListener('click', function () {
          self3.input.value = '';
          self3.input.dispatchEvent(new Event('input', { bubbles: true }));
          self3.input.focus();
        });
      }

      // clique fora fecha (o scrim cobre o resto da página no desktop)
      document.addEventListener('click', (e) => {
        if (this.classList.contains('is-open') && !this.contains(e.target)) this.close();
      });

      // cruzou o breakpoint com painel aberto: fecha (evita estado híbrido)
      this.mqMobile.addEventListener('change', () => { if (this.classList.contains('is-open')) this.close(); });
    }

    /* ---------- abertura / fechamento ---------- */

    open() {
      if (this.classList.contains('is-open')) return;
      this.classList.add('is-open');
      clearTimeout(this.closeT);
      this.panel.classList.remove('is-closing');
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      var root = this.results.querySelector('[data-results-count]');
      var hasResults = root && parseInt(root.dataset.resultsCount, 10) > 0;
      this.setState(this.input.value.trim() && hasResults ? 'results' : 'empty');

      if (this.mqMobile.matches) {
        // sheet abre da base da barra pra baixo (padrão StockX) — header fica intocado
        this.classList.add('is-takeover');
        this.fitSheet(); // top = base da barra; height = viewport visível (não fica atrás do teclado)
        if (window.visualViewport && !this._vvFit) {
          this._vvFit = this.fitSheet.bind(this);
          window.visualViewport.addEventListener('resize', this._vvFit);
        }
        // lock 1 frame depois: travar o body no meio do gesto de foco cancela o teclado no iOS (1º toque "não abria")
        var selfLock = this;
        requestAnimationFrame(function () { if (selfLock.classList.contains('is-open')) selfLock.lockScroll(); });
        if (this.cancelBtn) this.cancelBtn.hidden = false;
      } else {
        this.lockScroll(); // trava o scroll do fundo — search aberta é modal no desktop
        // fecha megamenu se aberto e assume o scrim
        var scrim = window.StealsHeader && window.StealsHeader.ensureScrim
          ? window.StealsHeader.ensureScrim()
          : null;
        if (scrim) {
          scrim.hidden = false;
          scrim.dataset.owner = 'search';
          this.onScrimClick = this.close.bind(this);
          scrim.addEventListener('click', this.onScrimClick);
        }
        if (window.StealsHeader && window.StealsHeader.closeMegamenu) {
          window.StealsHeader.closeMegamenu(true); // fecha limpo (aria/current), sem mexer no scrim
        } else {
          document.querySelectorAll('[data-megamenu-panel]').forEach(function (p) { p.hidden = true; });
        }
      }
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      clearTimeout(this.debounceT);
      this.stopLoading();
      if (this.controller) this.controller.abort();
      this.classList.remove('is-open');
      // saída com fade nos dois contextos; o sheet mantém is-takeover/top até o fim da animação
      var isSheet = this.classList.contains('is-takeover');
      if (isSheet) {
        if (this.cancelBtn) this.cancelBtn.hidden = true;
        if (this._vvFit && window.visualViewport) { window.visualViewport.removeEventListener('resize', this._vvFit); this._vvFit = null; }
      }
      this.unlockScroll(); // desfaz o lock aplicado no open (desktop e mobile)
      var canFade = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
      var panel = this.panel;
      var selfClose = this;
      var finish = function () {
        panel.hidden = true;
        panel.classList.remove('is-closing');
        if (isSheet) { selfClose.classList.remove('is-takeover'); panel.style.top = ''; panel.style.height = ''; }
      };
      if (canFade) {
        panel.classList.add('is-closing');
        this.closeT = setTimeout(finish, 120);
      } else {
        finish();
      }
      this.input.setAttribute('aria-expanded', 'false');
      this.clearActive();
      var scrim = document.querySelector('.steals-header__scrim');
      if (scrim && scrim.dataset.owner === 'search') {
        scrim.hidden = true;
        delete scrim.dataset.owner;
        if (this.onScrimClick) scrim.removeEventListener('click', this.onScrimClick);
      }
    }

    /* ---------- estados ---------- */

    setState(state) {
      this.results.hidden = state !== 'results';
      this.empty.hidden = state !== 'empty';
      this.noresults.hidden = state !== 'noresults';
      this.error.hidden = state !== 'error';
      this.collectOptions();
    }

    /* ---------- digitação / fetch ---------- */

    onInput() {
      clearTimeout(this.debounceT);
      var term = this.input.value.trim();
      if (this.clearBtn) this.clearBtn.hidden = !this.input.value;
      if (term && !this.classList.contains('is-open')) this.open();
      if (!term) {
        if (this.controller) this.controller.abort();
        this.setState('empty');
        return;
      }
      this.debounceT = setTimeout(() => this.fetchResults(term), 300);
    }

    stopLoading() {
      clearTimeout(this.loadingT);
      this.panel.classList.remove('is-loading');
    }

    renderResults(markup, term) {
      this.stopLoading();
      // HTML de section rendering da própria loja (ver nota de segurança no topo)
      this.results.innerHTML = markup;
      // re-init dos triggers de quick cart nos cards recém-injetados (padrão do tema)
      var qc = document.querySelector('quick-cart-drawer');
      if (qc && qc.initTriggers) qc.initTriggers();

      var root = this.results.querySelector('[data-results-count]');
      var count = root ? parseInt(root.dataset.resultsCount, 10) : 0;
      if (count > 0) {
        this.setState('results');
        this.announce(this.options.length + ' opções para "' + term + '"');
      } else {
        if (this.noresultsTerm) this.noresultsTerm.textContent = term;
        this.setState('noresults');
        this.announce('Nenhum resultado para "' + term + '"');
      }
    }

    async fetchResults(term) {
      var cached = this.cache.get(term);
      if (cached) {
        if (this.controller) this.controller.abort(); // resposta em voo de termo velho não pode cobrir o cache
        this.stopLoading();
        this.renderResults(cached, term);
        return;
      }
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      // hairline de loading só se a resposta demorar >300ms
      clearTimeout(this.loadingT);
      var self = this;
      this.loadingT = setTimeout(function () { self.panel.classList.add('is-loading'); }, 300);
      var url = window.Shopify.routes.root +
        'search/suggest?q=' + encodeURIComponent(term) +
        '&resources[type]=product,query,collection' +
        '&resources[limit]=8&resources[limit_scope]=each' +
        '&section_id=predictive-search';
      try {
        var response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error(response.status);
        var text = await response.text();
        if (!this.classList.contains('is-open')) return; // fechou enquanto buscava
        var markup = new DOMParser().parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        if (this.cache.size >= 20) this.cache.delete(this.cache.keys().next().value); // FIFO simples
        this.cache.set(term, markup);
        this.renderResults(markup, term);
      } catch (err) {
        if (err.name === 'AbortError') return; // request obsoleto — o caminho novo cuida do loading
        this.stopLoading();
        this.setState('error');
        this.announce('Erro ao buscar');
      }
    }

    announce(msg) { if (this.status) this.status.textContent = msg; }

    /* ---------- teclado / ARIA ---------- */

    collectOptions() {
      // cards da vitrine (card-product) entram no contrato de teclado: o link principal vira option
      this.panel.querySelectorAll('.product-card__link').forEach((el) => { el.setAttribute('role', 'option'); });
      this.clearActive();
      this.panel.querySelectorAll('[role="option"]').forEach((el) => el.removeAttribute('id'));
      this.options = Array.from(this.panel.querySelectorAll('[role="option"]'))
        .filter((el) => el.offsetParent !== null); // só visíveis
      this.options.forEach((el, i) => { el.id = 'steals-search-opt-' + i; });
    }

    clearActive() {
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');
      this.panel.querySelectorAll('.is-active').forEach((el) => el.classList.remove('is-active'));
    }

    setActive(index) {
      this.panel.querySelectorAll('.is-active').forEach((el) => el.classList.remove('is-active'));
      this.activeIndex = index;
      if (index < 0) { this.input.removeAttribute('aria-activedescendant'); return; }
      var opt = this.options[index];
      opt.classList.add('is-active');
      var pc = opt.closest('.product-card');
      if (pc) pc.classList.add('is-active');
      this.input.setAttribute('aria-activedescendant', opt.id);
      opt.scrollIntoView({ block: 'nearest' });
    }

    onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault(); // bloqueia o clear nativo do input[type=search] no Esc — o clear é nosso, no 2º Esc
        if (this.classList.contains('is-open')) { this.close(); }
        else if (this.input.value) { this.input.value = ''; this.input.dispatchEvent(new Event('input')); }
        return;
      }
      if (!this.classList.contains('is-open')) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!this.options.length) return;
        var delta = e.key === 'ArrowDown' ? 1 : -1;
        var next = this.activeIndex + delta;
        if (next >= this.options.length) next = 0;
        if (next < 0) next = this.options.length - 1;
        this.setActive(next);
        return;
      }
      if (e.key === 'Enter' && this.activeIndex >= 0) {
        e.preventDefault();
        this.options[this.activeIndex].click();
      }
    }

    onSubmit(e) {
      if (!this.input.value.trim()) { e.preventDefault(); return; } // não navega com busca vazia
      this.close();
    }

    /* ---------- scroll lock (padrão iOS-safe do menu drawer) ---------- */

    fitSheet() {
      // top na base real da barra; height até o topo do teclado (visualViewport) — conteúdo sempre alcançável
      var top = Math.round(this.form.getBoundingClientRect().bottom);
      var vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      this.panel.style.top = top + 'px';
      this.panel.style.height = Math.max(0, Math.round(vh - top)) + 'px';
    }

    lockScroll() {
      // Um único mecanismo p/ desktop e mobile: position:fixed no body guardando o scrollY.
      // É o padrão do menu drawer do tema e o único que trava sem PULO e mantém o header sticky
      // visível (medido: barra de busca fica no mesmo top). overflow:hidden no html falhava:
      // com html{height:100%} ele grampeava o scroll e saltava a página ao abrir rolado.
      this.savedScrollY = window.scrollY || window.pageYOffset || 0;
      var sbw = window.innerWidth - document.documentElement.clientWidth; // 0 em overlay scrollbars (macOS/mobile)
      document.body.style.position = 'fixed';
      document.body.style.top = (-this.savedScrollY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      if (sbw > 0) document.body.style.paddingRight = sbw + 'px'; // desktop c/ scrollbar clássica: sem pulo horizontal
    }

    unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.paddingRight = '';
      window.scrollTo(0, this.savedScrollY);
    }
  }

  customElements.define('steals-predictive-search', StealsPredictiveSearch);
}
